/**
 * ConventionBanner — Visual banner featuring the official "WITH YOU IT'S BETTER IN A UNION"
 * convention art. Auto-hides at midnight CT after June 10, 2026.
 */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, MapPin } from "lucide-react";

const CONVENTION_END = new Date("2026-06-11T05:00:00Z"); // midnight CT after June 10
const CONVENTION_IMG = "https://customer-assets.emergentagent.com/job_3ad4044b-aaab-459b-9d38-bfc229555674/artifacts/cp9jceos_IMG_8052.jpeg";

export default function ConventionBanner() {
  if (new Date() >= CONVENTION_END) return null;

  return (
    <Link
      to="/30th-convention"
      className="block relative overflow-hidden bg-black border-b-4 border-amber-500 group"
      data-testid="convention-banner"
      aria-label="Open the AFL-CIO 30th Convention page"
    >
      {/* Convention art — full bleed */}
      <img
        src={CONVENTION_IMG}
        alt="AFL-CIO 30th Constitutional Convention · Minneapolis June 7-10, 2026 · With You It's Better in a Union"
        className="w-full h-44 sm:h-56 md:h-72 object-cover object-center group-hover:scale-[1.02] transition-transform duration-500"
        loading="eager"
      />
      {/* Gradient + CTA pill */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 px-4 sm:px-6 py-3 sm:py-4 max-w-7xl mx-auto flex flex-wrap items-end justify-between gap-3 text-white">
        <div className="min-w-0">
          <div className="text-[10px] sm:text-xs uppercase tracking-[0.25em] text-amber-300 font-black mb-0.5">
            AFL-CIO 30TH CONSTITUTIONAL CONVENTION
          </div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm sm:text-base font-bold">
            <span className="inline-flex items-center gap-1.5"><Calendar className="w-4 h-4" /> June 7-10, 2026</span>
            <span className="inline-flex items-center gap-1.5 text-white/85"><MapPin className="w-4 h-4" /> Minneapolis Convention Center</span>
          </div>
        </div>
        <span className="inline-flex items-center gap-1.5 bg-amber-500 group-hover:bg-amber-400 text-slate-900 font-bold text-xs sm:text-sm px-3 sm:px-4 py-2 rounded-lg shadow flex-shrink-0 transition-colors">
          Open Convention Page <ArrowRight className="w-4 h-4" />
        </span>
      </div>
    </Link>
  );
}
